import axios from "axios";
import axiosInstance from "api/axiosInstance";
import { toast } from "react-toastify";

export const getknowlageBaseInfo = async (accessToken) => {
  try {
    const response = await axiosInstance.get("/business/@me", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      withCredentials: true,
    });
    return response.data;
  }
  // } catch (error) {
  //   if (error.response) {
  //     const status = error.response.status;
  //     const serverError = error.response.data?.error;

  //     if (serverError) toast.error(serverError);
  //     else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
  //     /*
  //     if (status == 403) {
  //       console.warn(
  //         "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
  //       );
  //       window.location.href = "/login";
  //       return;
  //     }
  //     throw {
  //       statusCode: status,
  //       message:
  //         error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
  //     };
  //     */
  //   } else {
  //     throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
  //   }
  // }
  catch (error) {
    if (error.response) {
      const status = error.response.status;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");

    } else {
      // خطاهای مربوط به شبکه یا سرور
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
  }
};

export const knowlageBase = async ({ accessToken, prompt, website, logo, customerPaymentEnabled, customerTokenPrice }) => {
  const data = { prompt, website, logo, customerPaymentEnabled, customerTokenPrice };
  try {
    const response = await axiosInstance.post("/business/@me", data, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      withCredentials: true,
    });
    return response.data;
  }
  //  catch (error) {
  //   if (error.response) {
  //     const status = error.response.status;
  //     const serverError = error.response.data?.error;

  //     if (serverError) toast.error(serverError);
  //     else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
  //     /*
  //     if (status === 403) {
  //       if (serverError === "Subscription has been expired or run out of tokens.") {
  //         toast.error("اشتراک شما منقضی شده یا توکن‌ها مصرف شده‌اند.");
  //       } else if (serverError === "Business tokens are used. You can reach out to the business owner for more information.") {
  //         toast.error("توکن های مصرفی برای پرامپت سیستمی بیش از حد مجاز است.");
  //       } else if (serverError === "Website URL is invalid, only https websites are allowed.") {
  //         toast.error("آدرس سایت وارد شده نامعتبر است، فقط سایت‌های با پروتکل https مجاز هستند.");
  //       }else if (serverError === "You reached your maximum token usage, please change your prompt.") {
  //         toast.error("توکن های مصرفی برای پرامپت سیستمی بیش از حد مجاز است.");
  //       }

  //       else {
  //         console.warn(
  //           "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
  //         );
  //         window.location.href = "/login";
  //         return;
  //       }
  //     } else if (status === 429) {
  //       if (serverError.startsWith("Your message is more than")) {
  //         toast.error("تعدا کاراکتر های  پرامپت سیستمی بیش از حد مجاز است.");
  //       }
  //     }*/
  //   } else {
  //     throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
  //   }
  catch (error) {
    if (error.response) {
      const status = error.response.status;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");

    } else {
      // خطاهای مربوط به شبکه یا سرور
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
  }
}

export const knowlageBaseEdit = async ({
  accessToken,
  prompt,
  website,
  logo,
  customerPaymentEnabled,
  customerTokenPrice
}) => {
  // const data = { prompt, website, logo };
  try {
    const response = await axiosInstance.patch(
      "/business/@me",
      { prompt, website, logo, customerPaymentEnabled, customerTokenPrice },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        withCredentials: true,
      }
    );
    return response.data;
  }
  // catch (error) {
  //   if (error.response) {
  //     const status = error.response.status;
  //     const serverError = error.response.data?.error;
  //     if (serverError) toast.error(serverError);
  //     else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
  //     /*
  //     if (status === 403) {
  //       if (serverError === "Subscription has been expired or run out of tokens.") {
  //         toast.error("اشتراک شما منقضی شده یا توکن‌ها مصرف شده‌اند.");
  //       } else if (serverError === "Business tokens are used. You can reach out to the business owner for more information.") {
  //         toast.error("توکن های مصرفی برای پرامپت سیستمی بیش از حد مجاز است.");
  //       } else if (serverError === "Website URL is invalid, only https websites are allowed.") {
  //         toast.error("آدرس سایت وارد شده نامعتبر است، فقط سایت‌های با پروتکل https مجاز هستند.");
  //       } else if (serverError === "You reached your maximum token usage, please change your prompt.") {
  //         toast.error("توکن های مصرفی برای پرامپت سیستمی بیش از حد مجاز است.");
  //       }

  //       else {
  //         console.warn(
  //           "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
  //         );
  //         window.location.href = "/login";
  //         return;
  //       }
  //     } else if (status === 429) {
  //       if (serverError.startsWith("Your message is more than")) {
  //         toast.error("تعدا کاراکتر های  پرامپت سیستمی بیش از حد مجاز است.");
  //       }
  //     }
  //     */
  //   } else {
  //     throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
  //   }
  // }
  catch (error) {
    if (error.response) {
      const status = error.response.status;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");

    } else {
      // خطاهای مربوط به شبکه یا سرور
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
  }
};

export const uploadFile = async ({ file, accessToken }) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axiosInstance.post(`/uploader/file`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
      },
      withCredentials: true, // If cookies/session authentication is used
    });
    return response.data;
  } catch (error) {
    console.log(error.response.data?.error);

    if (error.response) {
      const status = error.response.status;
      const serverError = error.response.data?.error;

      if (serverError) toast.error(serverError);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
      /*
      if (status === 403) {
        if (serverError === "Max file size has been reached.") {
          toast.error("حجم فایل آپلودی بیش از حد مجاز است.");
        } else if (serverError === "Max file counts has been reached.") {
          toast.error("با توجه به محدودیت تعداد فایل‌های مجاز، امکان آپلود فایل‌های بیشتر وجود ندارد.");
        } else if (serverError === "This file extension is not allowed.") {
          toast.error("این پسوند فایل مجاز نیست.");
        } else if (serverError === "File reaches the token limit.") {
          toast.error("تعداد توکن‌های مجاز برای این فایل بیشتر از حد مجاز است.");
        } else if (serverError === "Subscription has been expired or run out of tokens.") {
          toast.error("اشتراک شما منقضی شده یا توکن‌ها مصرف شده‌اند.");
        } else {
          console.warn(
            "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
          );
          window.location.href = "/login";
          return;
        }
      } else if (status === 429) {
        if (serverError.startsWith("Your file")) {
          toast.error("تعدا کاراکتر های فایل بیش از حد مجاز است.");
        }
      } else if (status === 428) {
        if (serverError.startsWith("Your file")) {
          toast.error("تعدا کاراکتر های فایل بیش از حد مجاز است.");
        }
      }
      */
    } else {
      toast.error(
        "خطا در اتصال به سرور. لطفاً اتصال اینترنت خود را بررسی کنید."
      );
    }
  }
};
export const uploadLogo = async ({ file, accessToken }) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axiosInstance.post(`/uploader/logo`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
      },
      withCredentials: true, // If cookies/session authentication is used
    });

    return response.data;
  } catch (error) {
    console.log(error.response.data?.error);

    if (error.response) {
      const status = error.response.status;
      const serverError = error.response.data?.error;

      if (serverError) toast.error(serverError);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
      /*
      if (status === 403) {
        if (serverError === "Max file size has been reached.") {
          toast.error("حجم فایل آپلودی بیش از حد مجاز است.");
        } else if (serverError === "Max file counts has been reached.") {
          toast.error("با توجه به محدودیت تعداد فایل‌های مجاز، امکان آپلود فایل‌های بیشتر وجود ندارد.");
        } else if (serverError === "This file extension is not allowed.") {
          toast.error("این پسوند فایل مجاز نیست.");
        } else if (serverError === "File reaches the token limit.") {
          toast.error("تعداد توکن‌های مجاز برای این فایل بیشتر از حد مجاز است.");
        } else if (serverError === "Subscription has been expired or run out of tokens.") {
          toast.error("اشتراک شما منقضی شده یا توکن‌ها مصرف شده‌اند.");
        } else {
          console.warn(
            "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
          );
          window.location.href = "/login";
          return;
        }
      }
      */
    } else {
      toast.error(
        "خطا در اتصال به سرور. لطفاً اتصال اینترنت خود را بررسی کنید."
      );
    }
  }
};
export const deleteFile = async ({ accessToken, fileName }) => {
  console.log('filename --- > ', fileName);
  try {
    const response = await axiosInstance.delete(`uploader/file/${fileName}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const serverError = error.response.data?.error;
      if (serverError) toast.error(serverError);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
      /*
      if (status === 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }

      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
      };
      */
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
